import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  useGridApiRef,
  GridBooleanCell,
} from '@mui/x-data-grid-premium';
import { Box, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { dataGridPremiumColumns } from '../../../utils/helper';
import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import { useState } from 'react';
import { EmployeeAttendanceSimpleMode } from '../../../utils/employeeAttendance';
import dayjs from 'dayjs';
import { formatCurrency, getRounding } from '../../../utils/currencyHelper';
import ProjectExtraWorkSimpleTaskAttachments from './ProjectExtraWorkSimpleTaskAttachments';
import useParam from '../../../context/ParamContext';

const ProjectExtraWorkSimpleTasksTable = ({ selectedValues }) => {
  const { params } = useParam();
  const apiRef = useGridApiRef();
  const [attachDialogData, setAttachDialogData] = useState({ open: false, attachments: [] });

  const columns = dataGridPremiumColumns([
    {
      field: 'simpleTaskName',
      headerName: 'Feladat rövid neve',
      type: 'string',
    },
    {
      field: 'startDate',
      headerName: 'Kezdő dátum',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.startDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.startDate).format('YYYY.MM.DD');
      },
    },
    {
      field: 'endDate',
      headerName: 'Befejező dátum',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.endDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.endDate).format('YYYY.MM.DD');
      },
    },
    {
      field: 'simpleTaskTypeId',
      headerName: 'Típus',
      type: 'string',
      renderCell: (data) => {
        return data.row.taskType?.itemName;
      },
    },
    {
      field: 'companyId',
      headerName: 'Cég',
      type: 'string',
      renderCell: (data) => {
        return data.row.company?.name;
      },
    },
    {
      field: 'statusId',
      headerName: 'Státusz',
      type: 'string',
      renderCell: (data) => {
        return data.row.status?.itemName;
      },
    },
    {
      field: 'resposiblePersonId',
      headerName: 'Felelős',
      type: 'string',
      renderCell: (data) => {
        return data.row.responsiblePerson?.nickName;
      },
    },
    {
      field: 'simpleTaskDescription',
      headerName: 'Megjegyzés',
      type: 'string',
    },
    {
      field: 'simpleTaskAttachment',
      headerName: 'Csatolmányok',
      type: 'string',
      renderCell: (data) => {
        return (
          <ButtonUI
            size="sm"
            className="bg-success px-2.5 py-1"
            onClick={() => {
              setAttachDialogData({
                open: true,
                attachments: data.row.simpleTaskAttachment,
              });
            }}
            text={
              <Box display="flex">
                <AttachFileIcon fontSize="small" />
                <Typography fontSize="medium">{data.row.simpleTaskAttachment.length}</Typography>
              </Box>
            }
          />
        );
      },
    },
  ]);

  const simpleTaskExtraWorkTypeId = params?.SIMPLETASK_EXTRA_WORK_TYPEID
    ? parseInt(params?.SIMPLETASK_EXTRA_WORK_TYPEID)
    : null;

  const rows = simpleTaskExtraWorkTypeId
    ? selectedValues?.simpleTask?.filter((task) => task.simpleTaskTypeId === simpleTaskExtraWorkTypeId)
    : [];

  return (
    <>
      <div className="overflow-x-auto">
        <div className="align-middle">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <DatagridPremiumUi
              apiRef={apiRef}
              datagridIdentifier={DataGridIdentifiers.ProjectExtraWorkSimpleTasksTable}
              height={460}
              columns={columns}
              rows={rows ?? []}
              headerFilters={false}
              slots={{
                toolbar: null,
              }}
              getRowId={(row) => row.simpleTaskId}
              getRowHeight={() => 'auto'}
            />
          </div>
        </div>
      </div>

      <ProjectExtraWorkSimpleTaskAttachments
        dialogData={attachDialogData}
        handleClose={() => setAttachDialogData({ open: false, attachments: [] })}
      />
    </>
  );
};

export default ProjectExtraWorkSimpleTasksTable;
